import type { BackgroundConfig } from '../../types'

/*
 * organic-seeds background.
 *
 * Every numeric constant the background renders from lives in THIS file — the
 * GLSL loop bound, the smooth-minimum radius, both theme palettes, the grain
 * cadence, the render-quality lever. `src/components/SiteBackground/*` reads
 * this and contains no brand-specific number. Values lifted verbatim from the
 * `stammbaum-six.html` prototype (`PAL`, `SCALE`, `TILE/FRAMES/FPS`, `--noise-o`)
 * — see docs/organic-seeds/SOURCE-BACKGROUND-AND-NAV.md §1.
 */
export const background: BackgroundConfig = {
  effect: 'lava',
  // 'auto' → 0.42 on desktop; the mobile lighter path (D-7) overrides to a
  // smaller scale regardless of this knob. See SiteBackground.scaleForQuality.
  quality: 'auto',
  pauseOnScroll: true,

  grain: {
    enabled: true,
    opacity: 0.06, // prototype --noise-o
    tileCount: 8, // prototype FRAMES
    fps: 14, // prototype FPS
  },

  lava: {
    blobCount: 7, // prototype `for(int i=0;i<7;i++)`
    sminRadius: 0.105, // prototype `smin(d, di, 0.105)`
    speed: 1,
    palette: {
      // linear-space RGB triples, straight from the prototype's PAL
      dark: {
        lo: [0.016, 0.038, 0.03],
        mid: [0.075, 0.3, 0.2],
        hi: [0.215, 0.5, 0.325],
        rim: [0.18, 0.4, 0.52],
        absorb: [1.55, 0.6, 1.05],
        alpha: 0.92,
      },
      light: {
        lo: [0.902, 0.924, 0.902],
        mid: [0.64, 0.79, 0.7],
        hi: [0.82, 0.9, 0.83],
        rim: [0.68, 0.77, 0.87],
        absorb: [0.7, 0.35, 0.55],
        alpha: 0.66,
      },
    },
  },

  // Alternates — selectable by switching `effect` above, no component edit.
  // Tuned toward the organic-seeds greens; secondary to the lava default.
  aurora: {
    bands: 3,
    speed: 1,
    colors: ['#0f5132', '#198754', '#20c997'],
  },
  grid: {
    cellSize: 48,
    lineWidth: 1,
    color: 'rgba(255, 255, 255, 0.045)',
  },
  dots: {
    spacing: 26,
    radius: 1.3,
    color: 'rgba(255, 255, 255, 0.06)',
  },
  topo: {
    lineCount: 12,
    amplitude: 22,
    color: 'rgba(255, 255, 255, 0.05)',
  },
}
